// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-card {
  height: 100%;
  border-radius: var(--radius-md);
  background: var(--bg-surface);
  border: 1px solid var(--border);
  box-shadow: none;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.dashboard-card:hover {
  border-color: var(--border-strong);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.dashboard-card.dragging {
  opacity: 0.85;
  border-color: var(--accent);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
  transform: scale(1.02);
}

.dashboard-card .ant-card-head {
  background: var(--bg-elevated);
  border-bottom: 1px solid var(--border);
  min-height: 48px;
  color: var(--text-primary);
}

.dashboard-card .ant-card-head-title {
  color: var(--text-primary);
}

.dashboard-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: var(--text-primary);
}

.dashboard-card .card-header svg {
  color: var(--accent-hover);
}

.dashboard-card .app-name {
  font-size: 12px;
  color: var(--text-muted);
  font-weight: normal;
  margin-left: auto;
  margin-right: 8px;
}

.dashboard-card .ant-card-body {
  background: var(--bg-surface);
}

.dashboard-card .drag-handle {
  cursor: move;
  color: var(--text-muted);
}

.dashboard-card .drag-handle:hover {
  color: var(--accent-hover);
}

.dashboard-card .card-setup {
  padding: 20px 0;
}

.dashboard-card .card-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
}

.dashboard-card .stats-content {
  position: relative;
  padding: 16px;
}

.dashboard-card .trend {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  padding: 4px 8px;
  background: var(--bg-hover);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
}

.dashboard-card .ant-statistic { margin-bottom: 12px; }

.dashboard-card .ant-statistic-title {
  font-size: 12px;
  color: var(--text-muted);
}

.dashboard-card .ant-statistic-content {
  font-size: 24px;
  color: var(--text-primary);
}

.dashboard-card .ant-progress { margin-top: 12px; }

.dashboard-card .ant-progress-text {
  color: var(--text-secondary) !important;
}

.dashboard-card .ant-empty-description {
  color: var(--text-muted);
}

.dashboard-card.card-type-push_stats  { border-top: 3px solid #3b82f6; }
.dashboard-card.card-type-user_stats  { border-top: 3px solid #22c55e; }
.dashboard-card.card-type-revenue     { border-top: 3px solid #f59e0b; }
.dashboard-card.card-type-ctr         { border-top: 3px solid #8b5cf6; }
.dashboard-card.card-type-app_stats   { border-top: 3px solid #ec4899; }
.dashboard-card.card-type-conversions { border-top: 3px solid #06b6d4; }`, "",{"version":3,"sources":["webpack://./src/components/dashboard/DashboardCard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,iCAAiC,mBAAmB,EAAE;;AAEtD;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,gCAAgC,gBAAgB,EAAE;;AAElD;EACE,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wCAAwC,6BAA6B,EAAE;AACvE,wCAAwC,6BAA6B,EAAE;AACvE,wCAAwC,6BAA6B,EAAE;AACvE,wCAAwC,6BAA6B,EAAE;AACvE,wCAAwC,6BAA6B,EAAE;AACvE,wCAAwC,6BAA6B,EAAE","sourcesContent":[".dashboard-card {\n  height: 100%;\n  border-radius: var(--radius-md);\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  box-shadow: none;\n  overflow: hidden;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.dashboard-card:hover {\n  border-color: var(--border-strong);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.dashboard-card.dragging {\n  opacity: 0.85;\n  border-color: var(--accent);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);\n  transform: scale(1.02);\n}\n\n.dashboard-card .ant-card-head {\n  background: var(--bg-elevated);\n  border-bottom: 1px solid var(--border);\n  min-height: 48px;\n  color: var(--text-primary);\n}\n\n.dashboard-card .ant-card-head-title {\n  color: var(--text-primary);\n}\n\n.dashboard-card .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  color: var(--text-primary);\n}\n\n.dashboard-card .card-header svg {\n  color: var(--accent-hover);\n}\n\n.dashboard-card .app-name {\n  font-size: 12px;\n  color: var(--text-muted);\n  font-weight: normal;\n  margin-left: auto;\n  margin-right: 8px;\n}\n\n.dashboard-card .ant-card-body {\n  background: var(--bg-surface);\n}\n\n.dashboard-card .drag-handle {\n  cursor: move;\n  color: var(--text-muted);\n}\n\n.dashboard-card .drag-handle:hover {\n  color: var(--accent-hover);\n}\n\n.dashboard-card .card-setup {\n  padding: 20px 0;\n}\n\n.dashboard-card .card-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 150px;\n}\n\n.dashboard-card .stats-content {\n  position: relative;\n  padding: 16px;\n}\n\n.dashboard-card .trend {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 4px 8px;\n  background: var(--bg-hover);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n}\n\n.dashboard-card .ant-statistic { margin-bottom: 12px; }\n\n.dashboard-card .ant-statistic-title {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.dashboard-card .ant-statistic-content {\n  font-size: 24px;\n  color: var(--text-primary);\n}\n\n.dashboard-card .ant-progress { margin-top: 12px; }\n\n.dashboard-card .ant-progress-text {\n  color: var(--text-secondary) !important;\n}\n\n.dashboard-card .ant-empty-description {\n  color: var(--text-muted);\n}\n\n.dashboard-card.card-type-push_stats  { border-top: 3px solid #3b82f6; }\n.dashboard-card.card-type-user_stats  { border-top: 3px solid #22c55e; }\n.dashboard-card.card-type-revenue     { border-top: 3px solid #f59e0b; }\n.dashboard-card.card-type-ctr         { border-top: 3px solid #8b5cf6; }\n.dashboard-card.card-type-app_stats   { border-top: 3px solid #ec4899; }\n.dashboard-card.card-type-conversions { border-top: 3px solid #06b6d4; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
